import React, { useState, useEffect, useCallback } from "react";
import { Configurations } from "../../../Utils/Configurations";
import './Cile-Content.scss';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import HeaderEpub from "../../../Components/Header-Epub/Header-Epub";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import ErrorModal from "../../../Components/ErrorModal/ErrorModal";

const CileContentEpubDetails = (props) => {

    const [loadingLivros, setLoadingLivros] = useState(false)
    const [capitulos, setCapitulos] = useState([]);
    const [edicaoCapituloIndex, setEdicaoCapituloIndex] = useState(null);
    const [habilitado, setHabilitado] = useState(true);
    const [loadingSalvar, setLoadingSalvar] = useState(false);
    const [status, setStatus] = useState();
    const [flagExtracao, setFlagExtracao] = useState(false);
    const [loadingReverter, setLoadingReverter] = useState(false);
    const [modalInfosSuccess, setModalInfosSuccess] = useState(false);
    const [modalReverter, setModalReverter] = useState(false);
    const [cap, setCap] = useState({});
    const [modalExcluir, setModalExcluir] = useState(false);
    const [message, setMessage] = useState('');
    const [errorModal, setErrorModal] = useState(false);

    const bookId = props.match.params.idLivro ? props.match.params.idLivro : ''

    const [formState, setFormState] = useState({
        titulo: '',
        subtitulo: '',
        autor: '',
        cileId: '',
        editora: '',
        versao: '',
        capitulos: ''
    })

    const edicaoBloqueada = !habilitado || flagExtracao;

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const chamadaLivro = useCallback(() => {
        setHabilitado(true)
        setLoadingLivros(true)
        const config = new Configurations();
        axios.get(config.apiBasePath + `/conteudo-cile/epub/detalhes-livro/${bookId}`)
            .then(response => {
                setFormState((prevState) => ({
                    ...prevState,
                    titulo: response.data.dados.title,
                    subtitulo: response.data.dados.subtitle,
                    autor: response.data.dados.author,
                    cileId: response.data.dados.cileId,
                    editora: response.data.dados.publisher,
                    versao: response.data.dados.version,
                }));
                setCapitulos(response.data.dados.summaries.map((capitulo) => (
                    capitulo.title
                )))
                setStatus(response.data.dados.approval_status)
                setFlagExtracao(response.data.dados.extract_flag)
                setLoadingLivros(false)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {

            });
    }, [bookId])

    useEffect(() => {
        if (bookId !== 'novo') {
            chamadaLivro()
        }
    }, [bookId, chamadaLivro])

    const salvarAlteracao = async () => {
        setLoadingSalvar(true)
        const config = new Configurations();
        const body = {
            producao: false,
            dados: {
                id: bookId === 'novo' ? '' : parseInt(bookId),
                version: formState.versao,
                title: formState.titulo,
                subtitle: formState.subtitulo,
                author: formState.autor,
                synopsis: '',
                publishing_company: 'Editora Brasil Seikyo Ltda',
                release_date: "",
                cile_book_id: '',
                visible: false,
                free: false,
                '1image': '',
                '1file': '',
                "1cataloging_record": "",
                "1ebook_file": "",
                "ecommerce_url": "",
                summaries:
                    capitulos.map((capitulo, index) => ({
                        chapter: index + 1,
                        title: capitulo,
                    }))
            }

        }

        if (bookId === 'novo') {
            await axios.post(config.apiBasePath + `/conteudo-cile/epub/novo-livro`, body)
                .then(response => {
                    console.log("🚀 ~ salvarAlteracao ~ response:", response.data)
                    setLoadingSalvar(false)
                    //response.data.resultados.id se torna o id da página -> passa para arquivos
                    props.history.push(`/cile/conteudo/epub/detalhes/arquivos/${response.data.resultados.id}`)

                }).catch(err => {
                    console.log("ERROR:", err)
                    setLoadingSalvar(false)
                    setMessage(err.response.data.message || 'Ocorreu um erro ao criar o livro. Tente novamente mais tarde.');
                    toggleErrorModal();
                });
        } else {
            await axios.put(config.apiBasePath + `/conteudo-cile/epub/atualiza-livro/${bookId}`, body)
                .then(response => {
                    console.log("Resultado da edição:", response.data)
                    setLoadingSalvar(false)
                    setMessage('Livro atualizado com sucesso!');
                    toggleModalInfos();

                }).catch(err => {
                    console.log("ERROR:", err)
                    setLoadingSalvar(false)
                    setMessage(err.response.data.message || 'Ocorreu um erro ao atualizar o livro. Tente novamente mais tarde.');
                    toggleErrorModal();
                });
        }
    }

    const handleAddCapitulo = (e) => {
        e.preventDefault();
        if (formState.capitulos) {
            setCapitulos([...capitulos, formState.capitulos]);
            setFormState({ ...formState, capitulos: '' });
        }
    }

    const handleEditCapitulo = (index) => {
        setEdicaoCapituloIndex(index);
        const capitulosAtualizados = [...capitulos];
        setCapitulos(capitulosAtualizados);
        setFormState({ ...formState, capitulos: capitulosAtualizados[index] });
    }

    const handleSaveEdicao = (edicaoCapituloIndex) => {
        const capitulosAtualizados = [...capitulos];
        capitulosAtualizados[edicaoCapituloIndex] = formState.capitulos;
        setCapitulos(capitulosAtualizados);
        setEdicaoCapituloIndex(null);
        setFormState({ ...formState, capitulos: '' });
    }

    const handleDeleteCapitulo = (index) => {
        const capitulosAtualizados = capitulos.filter((_, i) => i !== index);
        setCapitulos(capitulosAtualizados);
    }

    const handleMoveCapitulo = (index, direcao) => {
        if (edicaoCapituloIndex !== null) {
            return;
        }
        const novoIndex = index + direcao;
        if (novoIndex < 0 || novoIndex >= capitulos.length) {
            return;
        }
        const capitulosAtualizados = [...capitulos];
        [capitulosAtualizados[index], capitulosAtualizados[novoIndex]] = [capitulosAtualizados[novoIndex], capitulosAtualizados[index]];
        setCapitulos(capitulosAtualizados);
    }

    const reverterConteudo = () => {
        const config = new Configurations();
        setLoadingReverter(true);
        toggleModalReverter();

        axios.post(config.apiBasePath + `/conteudo-cile/epub/reverter-conteudo/${bookId}`, { producao: false })
            .then(response => {
                console.log("RESPONSE DATA: ", response.data)
                setLoadingReverter(false)
                setFlagExtracao(false)
                setStatus(response.data.approval_status)
                setEdicaoCapituloIndex(null)
                setMessage('Extração revertida com sucesso! Agora é possível editar as informações do livro e dos capítulos.');
                toggleModalInfos()
            }).catch(error => {
                console.log("ERROR: ", error)
                setLoadingReverter(false)
                setMessage(error.response.data.message || 'Ocorreu um erro ao reverter a extração.');
                toggleErrorModal();
            })
    }

    const toggleModalInfos = () => setModalInfosSuccess(!modalInfosSuccess);
    
    const toggleModalReverter = () => setModalReverter(!modalReverter);

    const toggleModalExcluir = (item, index) => {
        setCap({
            titulo: item,
            index: index
        });
        setModalExcluir(!modalExcluir);
    }

    const toggleErrorModal = () => {
        setErrorModal(!errorModal);
    }

    return (
        <div className="cile-remessas">
            <div className="row">
                {loadingLivros ? null :
                    <HeaderEpub
                        pageTitle={bookId === 'novo' ? 'CILE - Novo EPUB' : `CILE - Editar EPUB`}
                        nextPage={`arquivos/${bookId}`}
                        status={status}
                        etapa={1}
                        salvarAlteracao={salvarAlteracao}
                        bookId={bookId}
                        history={props.history}
                        loadingSalvar={loadingSalvar}
                        disableSalvar={edicaoBloqueada}
                    />
                }
            </div>

            <div className="row no-gutters">

                <div className="col-12">
                    <div className="card mx-1 mb-3 p-3">
                        <div className="row no-gutters align-items-center">
                            <div className="col-12 col-lg-8">
                                <h3>ETAPA 1</h3>
                                <p>Criação do livro e seus capítulos. Será necessário cadastrar as informações gerais do livro e seus respectivos capítulos (antigo fluxo via arquivo .xls)</p>
                                <ul>
                                    <li>Capítulos precisam estar exatamente igual está no docx</li>
                                    <li>Subtítulo não é obrigatório</li>
                                </ul>
                            </div>
                            {!loadingLivros && flagExtracao ? (
                                <div className="col-12 col-lg-4 mt-3 mt-lg-0 d-flex flex-column align-items-center">
                                    {loadingReverter ? (
                                        <div className="spinner-border text-danger" role="status" />
                                    ) : (
                                        <button className="btn btn-outline-danger" onClick={toggleModalReverter}>
                                            Reverter Extração
                                        </button>
                                    )}
                                    <p className="mb-0 mt-2">
                                        <small>Não é possível editar as informações do livro e dos capítulos enquanto a extração não for revertida.</small>
                                    </p>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-5">
                    <div className="card mx-1">
                        {loadingLivros ? <div className="spinner-border text-success" role="status" /> :
                            <div className="row no-gutters px-3 mt-4">

                                <div className="col-12 mb-3 px-2">
                                    <label className="pl-2"><strong>Título:</strong></label>
                                    <input name="titulo" type="text" className="form-control" autoComplete="off" value={formState.titulo} onChange={handleInputChange} required={true} disabled={edicaoBloqueada} />
                                </div>
                                <div className="col-12 mb-3 px-2">
                                    <label className="pl-2"><strong>Subtítulo:</strong></label>
                                    <input name="subtitulo" type="text" className="form-control" autoComplete="off" value={formState.subtitulo} onChange={handleInputChange} required={true} disabled={edicaoBloqueada} />
                                </div>

                                <div className="col-12 col-lg-8 mb-3 px-2">
                                    <label className="pl-2"><strong>Autor:</strong></label>
                                    <input name="autor" type="text" className="form-control" autoComplete="off" value={formState.autor} onChange={handleInputChange} required={true} disabled={edicaoBloqueada} />
                                </div>

                                <div className="col-12 col-lg-2 offset-lg-1 px-2">
                                    <label className="pl-2"><strong>Versão:</strong></label>
                                    <input name="versao" type="text" className="form-control" autoComplete="off" value={formState.versao} onChange={handleInputChange} required={true} disabled={edicaoBloqueada} />
                                </div>

                                {/* <div className="col-12 col-lg-8 mb-5 px-2">
                                    <label className="pl-2"><strong>Editora:</strong></label>
                                    <input name="editora" type="text" className="form-control" autoComplete="off" value={formState.editora} onChange={handleInputChange} required={true} disabled={!habilitado} />
                                </div> */}
                            </div>
                        }


                    </div>
                </div>

                <div className="col-12 col-lg-7">
                    <div className="card mx-1">
                        {loadingLivros ? <div className="spinner-border text-success" role="status" /> :
                            <div className="row no-gutters px-3 mt-4">
                                <div className="col-12 col-lg-12 mb-3">
                                    <label className="pl-2"><strong>Capítulos:</strong> <small className="pl-4">Digite o nome do capítulo e clique em "Adicionar".</small></label>
                                    <form onSubmit={handleAddCapitulo} className="d-flex align-items-center">
                                        <input name="capitulos" type="text" className="form-control mr-3" autoComplete="off" value={edicaoCapituloIndex !== null ? null : formState.capitulos} onChange={handleInputChange} required={true} disabled={edicaoBloqueada || edicaoCapituloIndex !== null} />
                                        <button type="submit" disabled={edicaoBloqueada || edicaoCapituloIndex !== null} className="btn btn-outline-success">Adicionar</button>
                                    </form>

                                    <ul className="list-group mt-3">
                                        {capitulos.map((capitulo, index) => (
                                            <li key={index} className="list-group-item  d-flex justify-content-between align-items-center">
                                                <div className="d-flex align-items-center" style={{ width: '80%' }}>
                                                    <div className="d-flex flex-column mr-3">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary btn-sm p-0"
                                                            onClick={() => handleMoveCapitulo(index, -1)}
                                                            disabled={edicaoBloqueada || edicaoCapituloIndex !== null || index === 0}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="m12 8l6 6H6z" /></svg>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary btn-sm p-0 mt-1"
                                                            onClick={() => handleMoveCapitulo(index, 1)}
                                                            disabled={edicaoBloqueada || edicaoCapituloIndex !== null || index === capitulos.length - 1}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="m12 16l-6-6h12z" /></svg>
                                                        </button>
                                                    </div>

                                                    {edicaoCapituloIndex === index ?

                                                        <form onSubmit={() => handleSaveEdicao(index)} className="d-flex align-items-center w-100">
                                                            <input name="capitulos" type="text" className="form-control mx-3" autoComplete="off" value={formState.capitulos} onChange={handleInputChange} required={true} disabled={edicaoBloqueada} />
                                                            <button type="submit" className="btn btn-outline-success btn-sm" disabled={edicaoBloqueada}>Salvar</button>
                                                        </form>
                                                        : capitulo
                                                    }
                                                </div>

                                                <div>
                                                    {edicaoCapituloIndex === index ?
                                                        <button onClick={() => setEdicaoCapituloIndex(null)} className="btn btn-outline-info btn-sm ml-2" disabled={edicaoBloqueada}>Cancelar</button>
                                                        :
                                                        <div className="d-flex">
                                                            <button onClick={() => handleEditCapitulo(index)} className="btn btn-outline-info btn-sm ml-2" disabled={edicaoBloqueada || (edicaoCapituloIndex !== null && edicaoCapituloIndex !== index)}>Editar</button>
                                                            <button onClick={() => toggleModalExcluir(capitulo, index)} className="btn btn-outline-danger btn-sm ml-2" disabled={edicaoBloqueada || (edicaoCapituloIndex !== null && edicaoCapituloIndex !== index)}>Excluir</button>
                                                        </div>
                                                    }
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        }


                    </div>
                </div>
            </div>

            <Modal isOpen={modalInfosSuccess} toggle={toggleModalInfos}>
                <ModalHeader toggle={toggleModalInfos}>
                    Sucesso
                </ModalHeader>
                <ModalBody>
                    <p>{message}</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { toggleModalInfos() }}>fechar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalExcluir} toggle={toggleModalExcluir}>
                <ModalHeader toggle={toggleModalExcluir}>
                    Excluir
                </ModalHeader>
                <ModalBody>
                    <p>Tem certeza que deseja excluir o capítulo <strong>{cap.titulo}</strong>?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => { toggleModalExcluir() }}>fechar</Button>
                    <Button color="danger" onClick={() => { handleDeleteCapitulo() }}>Confirmar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalReverter} toggle={toggleModalReverter}>
                <ModalHeader toggle={toggleModalReverter}>
                    Reverter Extração
                </ModalHeader>
                <ModalBody>
                    <p>Tem certeza que deseja reverter a extração de conteúdo?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => { toggleModalReverter() }}>fechar</Button>
                    <Button color="danger" onClick={() => { reverterConteudo() }}>Confirmar</Button>
                </ModalFooter>
            </Modal>

            <ErrorModal
                isOpen={errorModal}
                message={message}
                closeErrorModal={toggleErrorModal}
            />


        </div >
    )
}


export default withRouter(CileContentEpubDetails);